import styled from '@emotion/styled'
import { Button } from 'components/button/Button'
import { pxToRem } from 'utils/styled'

export const SContactCard = styled(Button)`
  padding: 1rem;
  height: unset;
  overflow-x: hidden;
  text-align: start;
  font-weight: normal;

  & p,
  & > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & > span {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: calc(${pxToRem(236)}rem - 2rem);
  }
`

export const SAvatarRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
`

export const SBottomRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
`

export const SAvatarContainer = styled.div`
  position: relative;
`

export const SStatusContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  & > svg {
    width: 18px;
    height: 18px;
  }
`

export const SLegacyTag = styled.span`
  background-color: var(--c-blue100);
  color: var(--c-blue500);
  width: fit-content;
  padding: 0.3rem 0.5rem;
  border-radius: 30px;
  font-weight: bold;
  font-family: var(--f-text);
  font-size: 11px;
  margin: 0.5rem 0;
`

export const SLoadingMask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  background-color: var(--c-gray300-transparent);
`
